var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 86,
    viewBox: "0 0 121 86",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 40877"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 120,
    height: 86,
    rx: 13.5,
    fill: "#3485AA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 40609"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 72",
    cx: 60.0102,
    cy: 43.4897,
    r: 22.5102,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 73",
    cx: 60.0094,
    cy: 43.4899,
    r: 14.6735,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 74",
    cx: 60.0106,
    cy: 43.4901,
    r: 7.83673,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 369"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.5812 19V23.4082H84.9894L79.1118 29.2857H74.7036V24.8776L80.5812 19Z",
    fill: "#3485AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0098 43.9796L74.7036 29.2857M80.5812 23.4082V19L74.7036 24.8776V29.2857M80.5812 23.4082L74.7036 29.2857M80.5812 23.4082H84.9894L79.1118 29.2857H74.7036",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBox);
export default __webpack_public_path__ + "static/media/blueBox.8031f768ad122d563774090d722f30ed.svg";
export { ForwardRef as ReactComponent };